import { GetRequirementStatusRequest } from '@eggplant/api-requests'
import { ComboboxSingleSelect } from '@eggplant/pattern-library'
import type {
  GetRequirementStatusResponse,
  Options,
  TestStatus
} from '@eggplant/types'
import type { ReactNode } from 'react'

interface Props {
  Icon?: ({ size }: { size: string }) => ReactNode
  value?: string
  onChange: (value: TestStatus | string) => void
}

const getStatusOptions = (data: GetRequirementStatusResponse): Options =>
  Object.keys(data).map(value => ({
    label: value[0].toUpperCase() + value.slice(1).toLowerCase(),
    value
  }))

const SelectRequirementsStatus = ({
  Icon,
  onChange,
  value
}: Props) =>
  <GetRequirementStatusRequest shortErrorMessage='Failed to load requirement status'>
    {
      ((data: GetRequirementStatusResponse) => {
        const statusOptions = getStatusOptions(data)

        return (
          <ComboboxSingleSelect
            Icon={Icon}
            categoryLabel='Status'
            isFilter
            isHighlighted={value !== ''}
            key={value}
            onChange={onChange}
            options={statusOptions}
            prompt='Requirement status'
            value={value}
          />
        )
      })
    }
  </GetRequirementStatusRequest>

export default SelectRequirementsStatus
